var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewVariableInline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "#C8C7C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 6,
    height: 6,
    fill: "#C8C7C7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 6,
    height: 6,
    fill: "#C8C7C7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 10,
    width: 15,
    height: 2,
    fill: "#C8C7C7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 18,
    width: 15,
    height: 2,
    fill: "#C8C7C7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    width: 15,
    height: 2,
    fill: "#C8C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewVariableInline);
export default __webpack_public_path__ + "static/media/view-variable-inline.89115921a5088bd287fddd86f8f73b98.svg";
export { ForwardRef as ReactComponent };